import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./AboutMe.css";
import aboutMe from "../../images/about-me.jpg";
import AOS from "aos";
import "aos/dist/aos.css";
const AboutMe = () => {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <Container>
      <Container data-aos="fade-down-right" className="text-center">
        <img
          src={aboutMe}
          className="img-fluid about-me-img mt-5 mb-4"
          alt=""
        />
        <h1 className="mt-4 font ">
          I am <span className="about-name">Md Moshiur Rahman Akash</span>
        </h1>

        <p className="text-secondary fs-5 font ">
          I am a passionate JavaScript developer. I've worked on a few projects
          that included modern HTML, CSS, ES6, and React.js. I always try to
          seek out new technologies and stay up-to-date on industry trends and
          advancements. I always focus on learning new technology. I am
          currently studying in the Department of Computer Science and
          Engineering, Daffodil International University.
        </p>
      </Container>

      <Container className="mx-auto m-5 font">
        <Row className="gy-5">
          <Col
            data-aos="fade-right"
            sm={12}
            md={6}
            lg={6}
            className="border-info border-4 border-end"
          >
            <h1 className="text-center font my-2 ">
              <span className="text-info">My</span>{" "}
              <span className=" heading ">Skills</span>
            </h1>
            <p className="fs-2 fw-bold text-secondary mt-4">
              <span className="text-info ">Comfortable</span>
            </p>
            <>
              <span className="badge fs-6 text-white fw-bold bg-secondary p-2">
                HTML5
              </span>
              <span className="badge fs-6 text-white fw-bold bg-secondary p-2 m-1">
                React JS
              </span>
              <span className="badge fs-6 badge-secondary text-white fw-bold bg-secondary p-2 m-1">
                React Bootstrap
              </span>
              <span className="badge fs-6 badge-secondary text-white fw-bold bg-secondary p-2 m-1">
                JavaScript (ES6)
              </span>
              <span className="badge fs-6 badge-secondary text-white fw-bold bg-secondary p-2 m-1">
                CSS3
              </span>
              <span className="badge fs-6 badge-secondary text-white fw-bold bg-secondary p-2 m-1">
                React Router v5
              </span>
            </>
            <p className="fs-2 fw-bold  ">
              <span className="text-info">Familiar</span>
            </p>
            <>
              <span className="badge fs-6 badge-secondary text-white fw-bold bg-secondary p-2 m-1">
                Tailwind CSS
              </span>
              <span className="badge fs-6 badge-secondary text-white fw-bold bg-secondary p-2 m-1">
                Material UI
              </span>
              <span className="badge fs-6 badge-secondary text-white fw-bold bg-secondary p-2 m-1">
                Express.js
              </span>
            </>
            <p className="fs-2 fw-bold text-info">Tools</p>
            <>
              <span className="badge fs-6 badge-secondary text-white fw-bold bg-secondary p-2 m-1">
                Git
              </span>
              <span className="badge fs-6 badge-secondary text-white fw-bold bg-secondary p-2 m-1">
                VS Code
              </span>
              <span className="badge fs-6 badge-secondary text-white fw-bold bg-secondary p-2 m-1">
                Heroku
              </span>
              <span className="badge fs-6 badge-secondary text-white fw-bold bg-secondary p-2 m-1">
                Chrome Dev Tool
              </span>
              <span className="badge fs-6 badge-secondary text-white fw-bold bg-secondary p-2 m-1">
                Firebase
              </span>
              <span className="badge fs-6 badge-secondary text-white fw-bold bg-secondary p-2 m-1">
                Netlify
              </span>
            </>
          </Col>
          <Col data-aos="fade-left" sm={12} md={6} lg={6}>
            <section className="education">
              <h1 className="text-center my-2">
                <span className="text-info">My </span>{" "}
                <span className="heading ">Education</span>
              </h1>

              <div className="my-4">
                <i className="fas fa-graduation-cap fs-2 text-info"></i>
                <span className="fs-3 text-info fw-bold fs-2">
                  {" "}
                  Under Graduation
                </span>

                <p className="mx-5">
                  <span className="fw-bold text-secondary">
                    {" "}
                    B.Sc in Computer Science & Engineering,
                  </span>
                  <br />

                  <span className="fw-bold text-secondary">
                    {" "}
                    Daffodil International University{" "}
                  </span>
                  <br />
                  <span className="fw-bold text-secondary">2020 - CURRENT</span>
                </p>
              </div>
              <div className="">
                <i className="fas fa-graduation-cap fs-3 text-info"></i>
                <span className="fs-3 text-info fw-bold">
                  {" "}
                  Higher Secondary
                </span>

                <p className="mx-5">
                  <span className="fw-bold text-secondary"> HSC 2019</span>
                  <br />

                  <span className="fw-bold text-secondary">Dhaka College </span>
                  <br />
                  <span className="fw-bold text-secondary">2017 - 2019</span>
                </p>
              </div>
            </section>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default AboutMe;
